export default function capitalToTitle(str) {
	return str
		.split('_')
		.map(prt => `${prt.charAt(0)}${prt.slice(1).toLowerCase()}`)
		.join('');
}
